import { CenterPanel } from './CenterPanel.component';
import { CollapsibleSidePanel } from './CollapsibleSidePanel.component';
import { LayoutContext } from './LayoutContext';
import { RegionType } from './RegionType.enum';
import { TopPanel } from './TopPanel.component';
import { Viewport } from './Viewport.component';

export default {
	RegionType,
	Viewport,
	TopPanel,
	CenterPanel,
	CollapsibleSidePanel,
	LayoutContext,
};
